import { BlogPost } from '../blog/types';
import post1 from '../blog/posts/ai-gold-rush';
import post2 from '../blog/posts/turbonium-token-system';
import post3 from '../blog/posts/market-shift';
import post4 from '../blog/posts/ethos';
import post5 from '../blog/posts/10x-explained';
import post6 from '../blog/posts/ai-is-multiplication-not-addition';
import post7 from '../blog/posts/the-power-of-verifiable-domains';

// Collect all blog posts
export const blogPosts: BlogPost[] = [post1, post2, post3, post4, post5, post6, post7];

// Get featured post
const PREFERRED_FEATURED_SLUG = 'the-ai-gold-rush-multiplying-business-capabilities';

export const getFeaturedPost = (): BlogPost => {
  const preferred = blogPosts.find((post) => post.slug === PREFERRED_FEATURED_SLUG);
  if (preferred) return preferred;

  const featured = blogPosts.find((post) => post.featured);
  return featured || blogPosts[0];
};

// Get post by slug
export const getPostBySlug = (slug: string): BlogPost | undefined => {
  return blogPosts.find((post) => post.slug === slug);
};

// Get post by ID
export const getPostById = (id: string): BlogPost | undefined => {
  return blogPosts.find((post) => post.id === id);
};

// Re-export types
export * from '../blog/types';
